module.exports = __webpack_public_path__ + "img/list-view.cf08cebe.svg";